var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQrcodeIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.3042 1.88259C42.3042 0.843001 43.147 0.000244141 44.1865 0.000244141L62.5918 0.000244141C63.6313 0.000244141 64.4741 0.843001 64.4741 1.88259V20.2878C64.4741 21.3274 63.6313 22.1701 62.5918 22.1701C61.5522 22.1701 60.7094 21.3274 60.7094 20.2878V3.76495L44.1865 3.76495C43.147 3.76495 42.3042 2.92219 42.3042 1.88259Z",
    fill: "#00013A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0624 1.88235C23.0624 0.842757 22.2196 0 21.18 0L2.77483 0C1.73523 0 0.892475 0.842757 0.892475 1.88235V20.2876C0.892475 21.3271 1.73523 22.1699 2.77483 22.1699C3.81442 22.1699 4.65718 21.3271 4.65718 20.2876V3.7647L21.18 3.7647C22.2196 3.7647 23.0624 2.92194 23.0624 1.88235Z",
    fill: "#00013A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.3041 62.1176C42.3041 63.1572 43.1468 64 44.1864 64H62.5916C63.6312 64 64.474 63.1572 64.474 62.1176V43.7124C64.474 42.6729 63.6312 41.8301 62.5916 41.8301C61.552 41.8301 60.7093 42.6729 60.7093 43.7124V60.2353H44.1864C43.1468 60.2353 42.3041 61.0781 42.3041 62.1176Z",
    fill: "#00013A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0624 62.1174C23.0624 63.157 22.2196 63.9998 21.18 63.9998H2.77483C1.73523 63.9998 0.892475 63.157 0.892475 62.1174V43.7122C0.892475 42.6726 1.73523 41.8299 2.77483 41.8299C3.81442 41.8299 4.65718 42.6726 4.65718 43.7122V60.2351H21.18C22.2196 60.2351 23.0624 61.0778 23.0624 62.1174Z",
    fill: "#00013A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4872 12.7583H19.5068V17.7779H14.4872V12.7583Z",
    fill: "#00013A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M46.278 12.7585H51.2976V17.7781H46.278V12.7585Z",
    fill: "#00013A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4872 46.2224H19.5068V51.242H14.4872V46.2224Z",
    fill: "#00013A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.25842 9.41189C9.25842 8.3723 10.1012 7.52954 11.1408 7.52954H22.8532C23.8928 7.52954 24.7355 8.3723 24.7355 9.41189V21.1243C24.7355 22.1639 23.8928 23.0066 22.8532 23.0066H11.1408C10.1012 23.0066 9.25842 22.1639 9.25842 21.1243V9.41189ZM13.0231 11.2942V19.2419H20.9708V11.2942H13.0231Z",
    fill: "#00013A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.0492 9.41189C41.0492 8.3723 41.892 7.52954 42.9315 7.52954H54.6439C55.6835 7.52954 56.5263 8.3723 56.5263 9.41189V21.1243C56.5263 22.1639 55.6835 23.0066 54.6439 23.0066H42.9315C41.892 23.0066 41.0492 22.1639 41.0492 21.1243V9.41189ZM44.8139 11.2942V19.2419H52.7616V11.2942H44.8139Z",
    fill: "#00013A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.25842 42.876C9.25842 41.8364 10.1012 40.9937 11.1408 40.9937H22.8532C23.8928 40.9937 24.7355 41.8364 24.7355 42.876V54.5884C24.7355 55.628 23.8928 56.4708 22.8532 56.4708H11.1408C10.1012 56.4708 9.25842 55.628 9.25842 54.5884V42.876ZM13.0231 44.7584V52.7061H20.9708V44.7584H13.0231Z",
    fill: "#00013A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M29.546 8.57544H32.8924V11.9218H29.546V8.57544Z",
    fill: "#00013A"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8923 8.57544H36.2387V11.9218H32.8923V8.57544Z",
    fill: "#00013A"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8923 11.9216H36.2387V15.268H32.8923V11.9216Z",
    fill: "#00013A"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M29.546 15.2681H32.8924V18.6145H29.546V15.2681Z",
    fill: "#00013A"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1996 18.6143H29.546V21.9607H26.1996V18.6143Z",
    fill: "#00013A"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1996 21.9609H29.546V25.3073H26.1996V21.9609Z",
    fill: "#00013A"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M29.546 21.9609H32.8924V25.3073H29.546V21.9609Z",
    fill: "#00013A"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8923 21.9607H36.2387V25.3071H32.8923V21.9607Z",
    fill: "#00013A"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8923 28.6536H36.2387V32H32.8923V28.6536Z",
    fill: "#00013A"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1996 28.6533H29.546V31.9997H26.1996V28.6533Z",
    fill: "#00013A"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8533 32.0002H26.1997V35.3466H22.8533V32.0002Z",
    fill: "#00013A"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8531 25.3071H26.1995V28.6535H22.8531V25.3071Z",
    fill: "#00013A"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8533 35.3464H26.1997V38.6928H22.8533V35.3464Z",
    fill: "#00013A"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M9.46765 28.6536H12.8141V32H9.46765V28.6536Z",
    fill: "#00013A"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8141 25.3069H16.1605V28.6533H12.8141V25.3069Z",
    fill: "#00013A"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1603 25.3071H19.5067V28.6535H16.1603V25.3071Z",
    fill: "#00013A"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1604 28.6536H19.5068V32H16.1604V28.6536Z",
    fill: "#00013A"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1603 32H19.5067V35.3464H16.1603V32Z",
    fill: "#00013A"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5068 28.6536H22.8532V32H19.5068V28.6536Z",
    fill: "#00013A"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8141 35.3464H16.1605V38.6928H12.8141V35.3464Z",
    fill: "#00013A"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M9.46753 35.3464H12.8139V38.6928H9.46753V35.3464Z",
    fill: "#00013A"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8923 32H36.2387V35.3464H32.8923V32Z",
    fill: "#00013A"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9709 52.0789H56.3173V55.4253H52.9709V52.0789Z",
    fill: "#00013A"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9707 25.3069H56.3171V28.6533H52.9707V25.3069Z",
    fill: "#00013A"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6244 28.6536H52.9708V32H49.6244V28.6536Z",
    fill: "#00013A"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9316 35.3464H46.278V38.6928H42.9316V35.3464Z",
    fill: "#00013A"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2778 32H49.6242V35.3464H46.2778V32Z",
    fill: "#00013A"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M46.278 42.0391H49.6244V45.3855H46.278V42.0391Z",
    fill: "#00013A"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6245 42.0391H52.9709V45.3855H49.6245V42.0391Z",
    fill: "#00013A"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M46.278 45.3853H49.6244V48.7317H46.278V45.3853Z",
    fill: "#00013A"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9708 42.0391H56.3172V45.3855H52.9708V42.0391Z",
    fill: "#00013A"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9708 45.3857H56.3172V48.7321H52.9708V45.3857Z",
    fill: "#00013A"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9316 45.3853H46.278V48.7317H42.9316V45.3853Z",
    fill: "#00013A"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6244 48.7319H52.9708V52.0783H49.6244V48.7319Z",
    fill: "#00013A"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M46.278 52.0786H49.6244V55.425H46.278V52.0786Z",
    fill: "#00013A"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9316 52.0784H46.278V55.4248H42.9316V52.0784Z",
    fill: "#00013A"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M29.546 35.3464H32.8924V38.6928H29.546V35.3464Z",
    fill: "#00013A"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1996 38.6929H29.546V42.0393H26.1996V38.6929Z",
    fill: "#00013A"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8923 38.6929H36.2387V42.0393H32.8923V38.6929Z",
    fill: "#00013A"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M29.546 42.0388H32.8924V45.3852H29.546V42.0388Z",
    fill: "#00013A"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M29.546 45.3855H32.8924V48.7319H29.546V45.3855Z",
    fill: "#00013A"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1996 45.3855H29.546V48.7319H26.1996V45.3855Z",
    fill: "#00013A"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M29.546 52.0786H32.8924V55.425H29.546V52.0786Z",
    fill: "#00013A"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2388 52.0786H39.5852V55.425H36.2388V52.0786Z",
    fill: "#00013A"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2388 48.7319H39.5852V52.0783H36.2388V48.7319Z",
    fill: "#00013A"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5852 48.7322H42.9316V52.0786H39.5852V48.7322Z",
    fill: "#00013A"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8923 48.7319H36.2387V52.0783H32.8923V48.7319Z",
    fill: "#00013A"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5852 42.0391H42.9316V45.3855H39.5852V42.0391Z",
    fill: "#00013A"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2388 42.0391H39.5852V45.3855H36.2388V42.0391Z",
    fill: "#00013A"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8923 45.3855H36.2387V48.7319H32.8923V45.3855Z",
    fill: "#00013A"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5852 38.6931H42.9316V42.0395H39.5852V38.6931Z",
    fill: "#00013A"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9316 28.6536H46.278V32H42.9316V28.6536Z",
    fill: "#00013A"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9316 25.3071H46.278V28.6535H42.9316V25.3071Z",
    fill: "#00013A"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6245 35.3464H52.9709V38.6928H49.6245V35.3464Z",
    fill: "#00013A"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9708 32H56.3172V35.3464H52.9708V32Z",
    fill: "#00013A"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2388 32H39.5852V35.3464H36.2388V32Z",
    fill: "#00013A"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5852 28.6536H42.9316V32H39.5852V28.6536Z",
    fill: "#00013A"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2388 25.3071H39.5852V28.6535H36.2388V25.3071Z",
    fill: "#00013A"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5852 35.3464H42.9316V38.6928H39.5852V35.3464Z",
    fill: "#00013A"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M46.278 38.6931H49.6244V42.0395H46.278V38.6931Z",
    fill: "#00013A"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2388 15.2681H39.5852V18.6145H36.2388V15.2681Z",
    fill: "#00013A"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2388 18.6143H39.5852V21.9607H36.2388V18.6143Z",
    fill: "#00013A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrcodeIcon);
export default __webpack_public_path__ + "static/media/qrcode-icon.7fa3aa3849ac1a780974ed2f04067a11.svg";
export { ForwardRef as ReactComponent };